// Import external
import { Directive, ElementRef, OnInit } from '@angular/core';

@Directive({
    selector: '[synGrid]'
})
export class GridDirective implements OnInit {

    constructor(private ele: ElementRef) {
    }

    ngOnInit() {
        this.ele.nativeElement.className = this.ele.nativeElement.className +
            ' syn-grid mdl-grid';
    }
}
